import { useState, useRef, useEffect } from "react"
import { Link } from "react-router-dom"
import { CircleUser, LogOut } from "lucide-react"
import { useLoggedIn } from "@/hooks/auth/useLoggedIn"

const ProfileDropdown = () => {
  const { closeSession, user, isLoggedIn } = useLoggedIn()
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  if (!isLoggedIn || user === null || user === undefined) {
    return null
  }

  return (
    <div ref={dropdownRef} className="ms-sm-3 header-item topbar-user relative">
      <button
        type="button"
        className="btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-haspopup="menu"
        aria-expanded={isOpen}
      >
        <span className="d-flex align-items-center">
          <span className="text-start ms-xl-2">
            <span className="d-xl-inline-block ms-1 fw-medium user-name-text">
              {user?.name}
            </span>
          </span>
        </span>
      </button>
      {isOpen && (
        <div
          role="menu"
          className="absolute right-0 top-full z-[1050] min-w-[200px] rounded-lg border border-border bg-popover py-1 text-popover-foreground shadow-lg"
        >
          <h6 className="m-0 px-4 py-2 text-[0.8rem] font-medium text-muted-foreground">
            ¡Bienvenido {user?.name}
          </h6>
          <div className="h-px bg-border" />
          <Link
            to="/perfil"
            role="menuitem"
            className="flex items-center gap-2 px-4 py-2 text-sm text-popover-foreground no-underline transition-colors hover:bg-muted/60"
            onClick={() => setIsOpen(false)}
          >
            <CircleUser className="h-4 w-4 text-muted-foreground" />
            <span>Perfil</span>
          </Link>
          <div className="h-px bg-border" />
          <Link
            to=""
            role="menuitem"
            onClick={(e) => { e.preventDefault(); closeSession(); setIsOpen(false) }}
            className="flex items-center gap-2 px-4 py-2 text-sm text-popover-foreground no-underline transition-colors hover:bg-muted/60"
          >
            <LogOut className="h-4 w-4 text-muted-foreground" />
            <span data-key="t-logout">Cerrar sesión</span>
          </Link>
        </div>
      )}
    </div>
  )
}

export default ProfileDropdown
